// 今日概况模块
const state = {
  my: 0,        // 码洋
  myTb: '0%',   // 码洋同比
  myHb: '0%',   // 码洋环比
  hds: 0,       // 活动数
  hdsTb: '0%',  // 活动数同比
  hdsHb: '0%',  // 活动数环比
  ddbs: 0,      // 订单笔数
  ddbsTb: '0%', // 订单笔数同比
  ddbsHb: '0%', // 订单笔数环比
  zdrs: 0,      // 征订人数
  zdrsTb: '0%', // 征订人数同比
  zdrsHb: '0%'  // 征订人数环比
}

const mutations = {
  SET_DATA(state, data) {
    if (data) {
      state.my = data.my || 0
      state.myTb = data.myTb || '0%'
      state.myHb = data.myHb || '0%'
      state.hds = data.hds || 0
      state.hdsTb = data.hdsTb || '0%'
      state.hdsHb = data.hdsHb || '0%'
      state.ddbs = data.ddbs || 0
      state.ddbsTb = data.ddbsTb || '0%'
      state.ddbsHb = data.ddbsHb || '0%'
      state.zdrs = data.zdrs || 0
      state.zdrsTb = data.zdrsTb || '0%'
      state.zdrsHb = data.zdrsHb || '0%'
    }
  },
  RESET_DATA(state) {
    state.my = 0
    state.myTb = '0%'
    state.myHb = '0%'
    state.hds = 0
    state.hdsTb = '0%'
    state.hdsHb = '0%'
    state.ddbs = 0
    state.ddbsTb = '0%'
    state.ddbsHb = '0%'
    state.zdrs = 0
    state.zdrsTb = '0%'
    state.zdrsHb = '0%'
  }
}

const getters = {
  data: state => state,
  // 四个核心指标
  coreMetrics: state => [
    { name: '码洋', value: state.my, tb: state.myTb, hb: state.myHb },
    { name: '活动数', value: state.hds, tb: state.hdsTb, hb: state.hdsHb },
    { name: '订单笔数', value: state.ddbs, tb: state.ddbsTb, hb: state.ddbsHb },
    { name: '征订人数', value: state.zdrs, tb: state.zdrsTb, hb: state.zdrsHb }
  ]
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
